import React from "react"
import Header from "../../components/Header"
import Footer from "../../components/Footer"
import MetadataSetHelmet from "../../components/utils/MetadataSetHelmet"
import "./style.scss"

function MainLayout(props) {
  return (
    <div className="mainLayout">
      <MetadataSetHelmet {...props.metadata} />
      <Header />
      <div className="mainContentContainer">{props.children}</div>
      <Footer />
    </div>
  )
}

export default MainLayout
